import { getEnvironmentFromHostname } from "./apiConfig";

// Allowlist rather than `!== "production"`: getEnvironmentFromHostname() returns the
// raw hostname for anything it doesn't recognise, so a negative check would re-enable
// the mocks on any new production domain or CDN edge. Unknown host must mean disabled.
const MOCK_ROUTE_ENVIRONMENTS = ["development", "dev", "staging", "labs"];

/**
 * Whether the mock verification routes may render.
 *
 * The mocks post a VERIFICATION_COMPLETE / outcome "passed" to their embedder using the
 * same protocol as the real flows, so on a production host they would hand any embedding
 * page a success message stamped with a trusted IDMe origin. They must never render there.
 *
 * Reads the iframe's own hostname, which the embedding page cannot influence.
 */
export function areMockRoutesEnabled(): boolean {
  return MOCK_ROUTE_ENVIRONMENTS.includes(getEnvironmentFromHostname());
}
